import React from 'react';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { createStackNavigator } from '@react-navigation/stack';
import { Text } from 'react-native';
import { ReceptionistDashboardScreen } from '../screens/receptionist/ReceptionistDashboardScreen';
import { AvailableSchedulesScreen } from '../screens/receptionist/AvailableSchedulesScreen';
import { CreateMeetingScreen } from '../screens/receptionist/CreateMeetingScreen';
import { MeetingHistoryScreen } from '../screens/receptionist/MeetingHistoryScreen';
import { MeetingDetailsScreen } from '../screens/receptionist/MeetingDetailsScreen';
import { useTheme } from '../theme/ThemeContext';

const Tab = createBottomTabNavigator();
const Stack = createStackNavigator();

const DashboardStack = () => (
  <Stack.Navigator screenOptions={{ headerShown: false }}>
    <Stack.Screen name="DashboardHome" component={ReceptionistDashboardScreen} />
    <Stack.Screen name="MeetingDetails" component={MeetingDetailsScreen} />
  </Stack.Navigator>
);

const HistoryStack = () => (
  <Stack.Navigator screenOptions={{ headerShown: false }}>
    <Stack.Screen name="HistoryHome" component={MeetingHistoryScreen} />
    <Stack.Screen name="MeetingDetails" component={MeetingDetailsScreen} />
  </Stack.Navigator>
);

export const ReceptionistNavigator = () => {
  const { isDark } = useTheme();

  return (
    <Tab.Navigator
      screenOptions={{
        headerShown: false,
        tabBarStyle: {
          backgroundColor: isDark ? '#0F172A' : '#FFFFFF',
          borderTopColor: isDark ? '#1E293B' : '#E2E8F0',
          height: 65,
          paddingBottom: 8,
          paddingTop: 8,
        },
        tabBarActiveTintColor: '#2563EB',
        tabBarInactiveTintColor: '#94A3B8',
      }}
    >
      <Tab.Screen
        name="Dashboard"
        component={DashboardStack}
        options={{
          tabBarLabel: 'Dashboard',
          tabBarIcon: ({ color }) => <Text style={{ color, fontSize: 18 }}>🏠</Text>,
        }}
      />
      <Tab.Screen
        name="AvailableSchedules"
        component={AvailableSchedulesScreen}
        options={{
          tabBarLabel: 'Schedules',
          tabBarIcon: ({ color }) => <Text style={{ color, fontSize: 18 }}>📅</Text>,
        }}
      />
      <Tab.Screen
        name="CreateMeeting"
        component={CreateMeetingScreen}
        options={{
          tabBarLabel: 'Book Meeting',
          tabBarIcon: ({ color }) => <Text style={{ color, fontSize: 18 }}>➕</Text>,
        }}
      />
      <Tab.Screen
        name="MeetingHistory"
        component={HistoryStack}
        options={{
          tabBarLabel: 'History',
          tabBarIcon: ({ color }) => <Text style={{ color, fontSize: 18 }}>📋</Text>,
        }}
      />
    </Tab.Navigator>
  );
};
